<div class="settings">
  <section class="settings__section">
    <header class="settings__header">
      <div class="settings__header-copy">
        <h3 class="settings__title">
          {{ 'app.components.profileSettings.title' | translate }}
        </h3>
        <p class="settings__subtitle">
          {{ 'app.components.profileSettings.subTitle' | translate }}
        </p>
      </div>
    </header>

    <div class="settings__body">
      <form [formGroup]="form" class="settings__form">
        <app-language-setting [control]="form.controls.language" />
        <app-email-notifications-setting
          [control]="form.controls.notificationsEmail"
        />
      </form>

      <div class="settings__actions">
        <app-parent-button
          variant="primary"
          [loading]="isSaving()"
          [disabled]="isSaving()"
          (clicked)="save()"
        >
          {{ 'app.components.profileSettings.save' | translate }}
        </app-parent-button>
      </div>
    </div>
  </section>
</div>
